import { StoreIssueDoc } from '@gooduncles/gu-app-schema';
import { Card, Empty } from 'antd';
import { FC } from 'react';

import { formatNumber } from 'src/utils/common';
import { formatDate } from 'src/utils/date-util';

import CardItem from 'src/atomic-components/atoms/CardItem/CardItem';
import Label from 'src/atomic-components/atoms/TextItem/Label';
import Value from 'src/atomic-components/atoms/TextItem/Value';

interface InventoryStoreIssueViewProps {
  storeIssue: StoreIssueDoc;
}

const InventoryStoreIssueView: FC<InventoryStoreIssueViewProps> = ({ storeIssue }) => {
  if (!storeIssue) {
    return <Empty description='매장 이슈 정보가 없습니다.' />;
  }
  return (
    <Card
      title='매장 이슈'
      style={{
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
      bodyStyle={{ overflow: 'scroll', flex: 1 }}>
      <CardItem>
        <Label>일자</Label>
        <Value>{formatDate(storeIssue.date, 'yyyy-MM-dd')}</Value>
      </CardItem>
      <CardItem>
        <Label>구분</Label>
        <Value>{storeIssue.category}</Value>
      </CardItem>
      <CardItem>
        <Label>이슈내용</Label>
        <Value>{storeIssue.message}</Value>
      </CardItem>
      <CardItem>
        <Label>진행상태</Label>
        <Value>
          {storeIssue.status}{' '}
          {storeIssue.completedAt && `(${formatDate(storeIssue.completedAt, 'yyyy-MM-dd HH:mm:ss')})`}
        </Value>
      </CardItem>
      <CardItem>
        <Label>매장</Label>
        <Value>
          {storeIssue.storeName} {storeIssue.storeCode && `(${storeIssue.storeCode})`}
        </Value>
      </CardItem>
      <CardItem>
        <Label>상품</Label>
        <Value>
          {storeIssue.productName} {storeIssue.productId && `(${storeIssue.productId})`}
        </Value>
      </CardItem>
      <CardItem>
        <Label>거래처</Label>
        <Value>{storeIssue.supplier}</Value>
      </CardItem>
      <CardItem>
        <Label>수량</Label>
        <Value>{storeIssue.volume}</Value>
      </CardItem>
      <CardItem>
        <Label>공급가</Label>
        <Value>
          {formatNumber(storeIssue.supplyPrice)} {storeIssue.tax && `(${formatNumber(storeIssue.tax)})`}
        </Value>
      </CardItem>
      <CardItem>
        <Label>파트너</Label>
        <Value>{storeIssue.deliveryPartnerName}</Value>
      </CardItem>
      <CardItem>
        <Label>특이사항</Label>
        <Value>{storeIssue.memo}</Value>
      </CardItem>
    </Card>
  );
};

export default InventoryStoreIssueView;
